
export enum EnumTipoTrabalho {
    MESA = 1,
    COMANDA = 2,
    BALCAO = 3
}